import { JwtAxios } from '@/packaging';
export const ownerClanApi = {
  async GetOwnerClanApiTemplate(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetOwnerClanApiTemplate?marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async SetOwnerClanApiTemplate(model) {
    const responseModel = await JwtAxios.post(`/Template/Market/SetOwnerClanApiTemplate`, model);
    return responseModel;
  },
  async SetOwnerClanApi(body) {
    const responseModel = await JwtAxios.post('/Template/Market/SetOwnerClanApi', body);
    return responseModel;
  }
};
